/* Vida Labs — PDP JS (v7)
   - Bundle picker → live updates ATC price
   - Gallery: scroll-snap carousel with dots + thumbs + mobile swipe
   - AJAX add-to-cart with subscription selling_plan, redirect to /checkout
   - Stock-bar fill animation
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.vlReady === '1') return;
    root.dataset.vlReady = '1';

    var form        = root.querySelector('#vl-atc-form');
    var btn         = root.querySelector('#vl-atc-btn');
    var label       = root.querySelector('#vl-atc-label');
    var priceEl     = root.querySelector('#vl-atc-price');
    var bundles     = root.querySelectorAll('.vl-bundle');
    var track       = root.querySelector('#vl-gallery-track');
    var dots        = root.querySelectorAll('.vl-gallery__dot');
    var thumbs      = root.querySelectorAll('.vl-thumb');
    var sellingPlan = root.getAttribute('data-selling-plan') || '';

    if (!form || !btn || !label || !bundles.length) return;

    function fmt(n) {
      var v = Number(n);
      if (!isFinite(v)) return '$0.00';
      return '$' + v.toFixed(2);
    }

    function getSelected() {
      for (var i = 0; i < bundles.length; i++) {
        var input = bundles[i].querySelector('input[type="radio"]');
        if (input && input.checked) return bundles[i];
      }
      return bundles[0];
    }

    function refreshLabel() {
      var sel = getSelected();
      if (!sel) return;
      var now = sel.getAttribute('data-now');
      if (priceEl) priceEl.textContent = fmt(now);
    }

    /* ---------- bundle radio change handlers ---------- */
    bundles.forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (!input) return;
      input.addEventListener('change', refreshLabel);
      card.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ---------- gallery scroll-snap + dots + thumbs ---------- */
    if (track) {
      function activate(idx) {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }
      function scrollToSlide(idx) {
        var slides = track.children;
        if (slides[idx]) {
          // Use scrollLeft directly to be reliable across mobile browsers
          track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { scrollToSlide(i); activate(i); });
      });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { scrollToSlide(i); activate(i); });
      });
      // Update active dot/thumb as the user swipes
      var scrollTO;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTO);
        scrollTO = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          activate(idx);
        }, 60);
      });
    }

    /* ---------- low-stock fill animation ---------- */
    var fillEls = root.querySelectorAll('.vl-lowstock__fill');
    if (fillEls.length) {
      requestAnimationFrame(function () {
        fillEls.forEach(function (el) { el.classList.add('is-filled'); });
      });
    }

    /* ---------- AJAX add to cart → /checkout ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      var sel = getSelected();
      if (!sel) return;
      var vid = sel.getAttribute('data-vid');
      if (!vid) return;

      var item = { id: parseInt(vid, 10), quantity: 1 };
      if (sellingPlan) {
        item.selling_plan = parseInt(sellingPlan, 10);
      }

      var originalLabel = label.textContent;
      var originalPrice = priceEl ? priceEl.textContent : '';
      btn.disabled = true;
      label.textContent = 'Procesando';
      if (priceEl) priceEl.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (err) {
              throw new Error('ATC ' + r.status + ': ' + (err && err.description ? err.description : 'unknown'));
            });
          }
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[vl-pdp] add-to-cart error', err);
          btn.disabled = false;
          label.textContent = originalLabel;
          if (priceEl) priceEl.textContent = originalPrice;
          alert('No pudimos agregar el producto. Intenta de nuevo en un momento.');
        });
    });

    refreshLabel();
  }

  function boot() {
    document.querySelectorAll('.vl-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target && e.target.querySelector ? e.target.querySelector('.vl-pdp') : null;
    if (sec) init(sec);
  });
})();
